import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "../../services/apiSlice";
import commonReducer from "../featuresSlice/commonSlice";
import tutorialsReducer from "../featuresSlice/TutorialsSlice";

export const store = configureStore({
    reducer: {
        [apiSlice.reducerPath]: apiSlice.reducer,
        common: commonReducer,
        tutorials: tutorialsReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(apiSlice.middleware),
});

export default store;
